<template>
  <div class="my-3 rounded-md w-full bg-red-100 px-4 py-3 text-sm">
    <p class="text-red-700">{{ prop.errorMessage }}</p>
  </div>
</template>
<script setup lang="ts">
const prop = defineProps<{
  errorMessage: string;
}>();
</script>
